import { MenuItem, Pagination, PaginationItem, Select } from "@mui/material";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

interface PaginationProps {
  /** total number of pages (list?.pages) */
  count: number;
  /** current page (1-based) */
  page: number;
  /** total number of records (list?.total) */
  total: number;
  /** list?.page_number — when falsy the range text shows 0 */
  pageNumber?: number;
  /** MUI Pagination onChange handler, receives (event, page) */
  onChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
  /** available page-size options (rowsCountList) */
  rowsCountList?: any[];
  /** current page-size value (count state) */
  countValue: number;
  /** called with the selected page-size value */
  onChangeCount: (value: any) => void;
}

export default function PaginationComponent({
  count,
  page,
  total,
  pageNumber,
  onChangePage,
  rowsCountList,
  countValue,
  onChangeCount,
}: PaginationProps) {
  const start = pageNumber ? (page - 1) * countValue + 1 : 0;
  const end = pageNumber ? Math.min(page * countValue, total) : 0;

  return (
    <div className="pagination-container">
      <div className="pagination-item">
        <Select
          value={countValue}
          onChange={(e: any) => onChangeCount(e.target.value)}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
        >
          {rowsCountList &&
            rowsCountList?.map((item: any, index: number) => {
              return (
                <MenuItem value={item} key={index}>
                  {item}
                </MenuItem>
              );
            })}
        </Select>
      </div>

      <Pagination
        className="custom-pagination"
        count={count ? count : 1}
        onChange={(event, value) => {
          // clicking the already-active page should not trigger a new request
          if (value !== page) {
            onChangePage(event, value);
          }
        }}
        size="small"
        page={page}
        renderItem={(item) => (
          <PaginationItem
            slots={{
              previous: IoIosArrowForward,
              next: IoIosArrowBack,
            }}
            {...item}
          />
        )}
      />

      <span className="pagination-text">
        نمایش <b>{start}</b> - <b>{end}</b> از <b>{total}</b>
      </span>
    </div>
  );
}